import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getUsersList: function ({limit = 9999, page = 1, filter, assigned = false, search}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`, 'sort[]=username']
    if (filter) fullRequest.push(filter)
    if (assigned) fullRequest.push(`assigned=${assigned}`)
    if (search) fullRequest.push(`search=${search}`)
    const api = search ? 'users?' : 'users/withoutelastic?'
    return instCred.get(api + fullRequest.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Users/api.js